import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ZapIcon, BarChart3Icon, UsersIcon, MailIcon, PhoneIcon, CalendarIcon, BrainIcon, ShieldCheckIcon } from 'lucide-react';
const benefits = [{
  icon: ZapIcon,
  title: 'Automatisierte Workflows',
  description: 'Eliminieren Sie repetitive Aufgaben. Leads werden automatisch zugewiesen, Follow-ups geplant und Erinnerungen gesendet.',
  metric: '89% Zeitersparnis'
}, {
  icon: BarChart3Icon,
  title: 'Echtzeit-Pipeline-Übersicht',
  description: 'Sehen Sie auf einen Blick, wo jeder Deal steht. Präzise Umsatzprognosen basierend auf echten Daten, nicht auf Bauchgefühl.',
  metric: '95% Prognosegenauigkeit'
}, {
  icon: UsersIcon,
  title: 'Team-Transparenz',
  description: 'Jede Aktivität wird automatisch geloggt. Sie wissen genau, wer wann was mit welchem Kunden besprochen hat.',
  metric: '100% Aktivitäts-Tracking'
}, {
  icon: MailIcon,
  title: 'E-Mail-Sequenzen',
  description: 'Erstellen Sie personalisierte E-Mail-Kampagnen, die automatisch zur richtigen Zeit gesendet werden. Nie wieder vergessene Follow-ups.',
  metric: '3x höhere Antwortrate'
}, {
  icon: PhoneIcon,
  title: 'Integrierte Telefonie',
  description: 'Rufen Sie direkt aus Close an. Gespräche werden automatisch aufgezeichnet und transkribiert. Volle Integration mit Ihrer Telefonanlage.',
  metric: '40% mehr Anrufe/Tag'
}, {
  icon: CalendarIcon,
  title: 'Smart Scheduling',
  description: 'Automatische Terminplanung mit Kalender-Sync. Kunden buchen selbst – ohne E-Mail-Ping-Pong.',
  metric: '67% weniger No-Shows'
}, {
  icon: BrainIcon,
  title: 'KI-gestützte Insights',
  description: 'Close analysiert Ihre Daten und gibt Empfehlungen. Welche Deals brauchen Aufmerksamkeit? Wo liegen Chancen?',
  metric: '23% mehr Conversions'
}, {
  icon: ShieldCheckIcon,
  title: 'DSGVO-konform',
  description: 'Alle Daten werden sicher in der EU gespeichert. Vollständige DSGVO-Compliance mit Audit-Trail und Löschfunktionen.',
  metric: '100% Compliance'
}];
export function BenefitsGrid() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" ref={ref} data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-13">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-14">
            Ihre Vorteile
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-15">
            8 Gründe, warum Close CRM Ihren Vertrieb transformiert
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-16">
            Jeder Vorteil ist messbar. Wir zeigen Ihnen genau, welchen Impact
            Sie erwarten können.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-17">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-6 rounded-2xl bg-[#1a1a1a] border border-white/5 hover:border-[#0ea5e9]/30 transition-colors duration-300" data-id="element-18">
              <div className="w-12 h-12 rounded-xl bg-[#0ea5e9]/10 flex items-center justify-center mb-4 group-hover:bg-[#0ea5e9]/20 transition-colors" data-id="element-19">
                <benefit.icon className="w-6 h-6 text-[#0ea5e9]" data-id="element-20" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-22">
                {benefit.description}
              </p>
              <div className="pt-4 border-t border-white/5" data-id="element-23">
                <span className="text-[#0ea5e9] font-semibold text-sm" data-id="element-24">
                  {benefit.metric}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}